import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import Api from "../../../shared/api/api";

const SettingsContext = createContext(null);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  const loadSettings = useCallback(async () => {
    setIsLoading(true);
    setError("");

    try {
      const response = await Api.getSettings();

      const nextSettings =
        response?.settings && typeof response.settings === "object"
          ? response.settings
          : {};

      setSettings(nextSettings);
    } catch (requestError) {
      console.error("Unable to load publishing settings:", requestError);

      setSettings({});
      setError("Unable to load the site settings.");
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    loadSettings();
  }, [loadSettings]);

  const contextValue = useMemo(
    () => ({
      settings,
      isLoading,
      error,
      refreshSettings: loadSettings,
    }),
    [settings, isLoading, error, loadSettings]
  );

  return (
    <SettingsContext.Provider value={contextValue}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  const context = useContext(SettingsContext);

  if (!context) {
    throw new Error(
      "useSettings must be used within a SettingsProvider."
    );
  }

  return context;
}